import { useMutation } from "@tanstack/react-query"
import { projectsApi } from "../api/projects"
import type {
  ProjectImportAnalysis,
  ProjectImportPreview,
  ProjectImportConfirmation,
  ProjectImportResult,
} from "./types"

// Hook to download template
export const useDownloadTemplate = () => {
  return useMutation({
    mutationFn: async () => {
      const blob = await projectsApi.import.getTemplate()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = "project_template.xlsx"
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    },
  })
}

// Hook to analyze Excel file
export const useAnalyzeExcel = () => {
  return useMutation<ProjectImportAnalysis, Error, File>({
    mutationFn: (file) => projectsApi.import.analyzeExcel(file),
  })
}

// Hook to preview Excel import
export const usePreviewImport = () => {
  return useMutation<ProjectImportPreview, Error, File>({
    mutationFn: (file) => projectsApi.import.previewImport(file),
  })
}

// Hook to confirm import
export const useConfirmImport = () => {
  return useMutation<ProjectImportResult, Error, ProjectImportConfirmation>({
    mutationFn: (data) => projectsApi.import.confirmImport(data),
  })
}
